<template>
  <EmdFormGroup
    :label="$t('ddd')"
    :state="getState($v.recipient.phone_numbers.ddd)"
    :feedbacks="feedbacks($v.recipient.phone_numbers.ddd)"
  >
    <EmdInput
      @input="() => $v.recipient.phone_numbers.ddd.$touch()"
      v-model="recipient.phone_numbers[0].ddd"
      mask="(##)"
      name="ddd"
    />
  </EmdFormGroup>
</template>
<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'

export default {
  name: 'PhoneAreaInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    ddd: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "ddd": "DDD"
    },
    "en-US": {
      "ddd": "DDD"
    }
  }
</i18n>
